import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";
import ComingSoon from "../pages/comingSoon";
import Login from "../auth/login/login";
import Register from "../auth/register/register";
import TwoStepVerification from "../auth/twoStepVerification/twoStepVerification";
import ResetPassword from "../auth/resetPassword/resetPassword";
import ForgotPassword from "../auth/forgotPassword/forgotPassword";
import Accordion from "../uiInterface/base-ui/accordion";
import Avatar from "../uiInterface/base-ui/avatar";
import Borders from "../uiInterface/base-ui/borders";
import Breadcrumb from "../uiInterface/base-ui/breadcrumb";
import Buttons from "../uiInterface/base-ui/buttons";
import ButtonsGroup from "../uiInterface/base-ui/buttonsgroup";
import Cards from "../uiInterface/base-ui/cards";
import Carousel from "../uiInterface/base-ui/carousel";
import Colors from "../uiInterface/base-ui/colors";
import Dropdowns from "../uiInterface/base-ui/dropdowns";
import Grid from "../uiInterface/base-ui/grid";
import Images from "../uiInterface/base-ui/images";
import Lightboxes from "../uiInterface/base-ui/lightbox";
import Media from "../uiInterface/base-ui/media";
import Modals from "../uiInterface/base-ui/modals";
import NavTabs from "../uiInterface/base-ui/navtabs";
import Offcanvas from "../uiInterface/base-ui/offcanvas";
import Pagination from "../uiInterface/base-ui/pagination";
import Popovers from "../uiInterface/base-ui/popover";
import RangeSlides from "../uiInterface/base-ui/rangeslider";
import Progress from "../uiInterface/base-ui/progress";
import Spinner from "../uiInterface/base-ui/spinner";
import Toasts from "../uiInterface/base-ui/toasts";
import Typography from "../uiInterface/base-ui/typography";
import Video from "../uiInterface/base-ui/video";
import Error404 from "../pages/error/error-404";
import Error500 from "../pages/error/error-500";
import UnderMaintenance from "../pages/underMaintenance";
import ClipBoard from "../uiInterface/advanced-ui/clipboard";
import DragAndDrop from "../uiInterface/advanced-ui/dragdrop";
import Rating from "../uiInterface/advanced-ui/rating";
import Apexchart from "../uiInterface/charts/apexcharts";
import FeatherIcons from "../uiInterface/icons/feathericon";
import FontawesomeIcons from "../uiInterface/icons/fontawesome";
import MaterialIcons from "../uiInterface/icons/materialicon";
import PE7Icons from "../uiInterface/icons/pe7icons";
import SimplelineIcons from "../uiInterface/icons/simplelineicon";
import ThemifyIcons from "../uiInterface/icons/themify";
import TypiconIcons from "../uiInterface/icons/typicons";
import WeatherIcons from "../uiInterface/icons/weathericons";
import BasicInputs from "../uiInterface/forms/formelements/basic-inputs";
import CheckboxRadios from "../uiInterface/forms/formelements/checkbox-radios";
import InputGroup from "../uiInterface/forms/formelements/input-group";
import GridGutters from "../uiInterface/forms/formelements/grid-gutters";
import FormSelect from "../uiInterface/forms/formelements/form-select";
import FormMask from "../uiInterface/forms/formelements/form-mask";
import FileUpload from "../uiInterface/forms/formelements/fileupload";
import FormHorizontal from "../uiInterface/forms/formelements/layouts/form-horizontal";
import FormVertical from "../uiInterface/forms/formelements/layouts/form-vertical";
import FloatingLabel from "../uiInterface/forms/formelements/layouts/floating-label";
import FormValidation from "../uiInterface/forms/formelements/layouts/form-validation";
import FormSelect2 from "../uiInterface/forms/formelements/layouts/form-select2";
import FormWizard from "../uiInterface/forms/formelements/form-wizard";
import TablesBasic from "../uiInterface/table/tables-basic";
import IonicIcons from "../uiInterface/icons/ionicicons";
import Badges from "../uiInterface/base-ui/badges";
import Placeholder from "../uiInterface/base-ui/placeholder";
import Alert from "../uiInterface/base-ui/alert";
import Tooltips from "../uiInterface/base-ui/tooltips";
import AdminDashboard from "../mainMenu/adminDashboard";
import AlertUi from "../uiInterface/base-ui/alert-ui";
import ResetPassword2 from "../auth/resetPassword/resetPassword-2";
import ResetPassword3 from "../auth/resetPassword/resetPassword-3";
import TwoStepVerification2 from "../auth/twoStepVerification/twoStepVerification-2";
import TwoStepVerification3 from "../auth/twoStepVerification/twoStepVerification-3";
import ResetPasswordSuccess from "../auth/resetPasswordSuccess/resetPasswordSuccess";
import ResetPasswordSuccess2 from "../auth/resetPasswordSuccess/resetPasswordSuccess-2";
import ResetPasswordSuccess3 from "../auth/resetPasswordSuccess/resetPasswordSuccess-3";
import Profile from "../pages/profile";
import LockScreen from "../auth/lockScreen";
import EmployeeDashboard from "../mainMenu/employeeDashboard/employee-dashboard";
import LeadsDasboard from "../mainMenu/leadsDashboard";
import DealsDashboard from "../mainMenu/dealsDashboard";
import Leaflet from "../uiInterface/map/leaflet";
import BootstrapIcons from "../uiInterface/icons/bootstrapicons";
import RemixIcons from "../uiInterface/icons/remixIcons";
import FlagIcons from "../uiInterface/icons/flagicons";
import Swiperjs from "../uiInterface/base-ui/swiperjs";
import Sortable from "../uiInterface/base-ui/ui-sortable";
import PrimeReactChart from "../uiInterface/charts/prime-react-chart";
import ChartJSExample from "../uiInterface/charts/chartjs";
import FormPikers from "../uiInterface/forms/formelements/formpickers";
import Calendars from "../mainMenu/apps/calendar";
import StarterPage from "../pages/starter";
import UnderConstruction from "../pages/underConstruction";
import PrivacyPolicy from "../pages/privacy-policy";
import TermsCondition from "../pages/terms-condition";
import Gallery from "../pages/gallery";
import Knowledgebase from "../administration/help-support/knowledgebase";
import SuperAdminDashboard from "../super-admin/dashboard";
import LayoutDemo from "../mainMenu/layout-dashoard";
import InvoiceDetails from "../sales/invoiceDetails";
import EmployeeList from "../hrm/employees/employeesList";
import BranchesList from "../hrm/Branches/branchesList";
import PlansList from "../hrm/Plans/planLists";
import StaffList from "../hrm/Staff/staff";
import PaidEmiList from "../hrm/EmisRecords/pendingEmis";
import PendingEmisList from "../hrm/EmisRecords/paidEmis";
import DistributorList from "../hrm/distributor/distributor";
import SuperDistributorList from "../hrm/superDistributor/superDistributor";
import UsersList from "../hrm/users/users";
import FinancersList from "../hrm/financers/financersList";
import CustomersList from "../hrm/customers/customerList";
import EvLoans from "../hrm/ev-loans/EvLoans";
import EvApplyPage from "../hrm/ev-loans/EvApplyPage";
import EvCustomerPage from "../hrm/ev-loans/EvCustomerPage";
import EvLoanRecordPage from "../hrm/ev-loans/EvLoanRecordPage";
import EvLoanDisbursementPage from "../hrm/ev-loans/EvLoanDisbursementPage";
import ReatailersList from "../hrm/retailers/retailersList";
import ProductList from "../hrm/products/productLists";
import ProductNameList from "../hrm/products/productNameList";
import DirectorList from "../hrm/directors/directorsList";
import DiscountsList from "../hrm/discounts/discounts";
import AdvertisementList from "../hrm/advertisement/advertisement";
import CustomerLoanList from "../hrm/customers/customerLoanList";
import VerificationList from "../hrm/verifications/verifications";
import LoanStatus from "../hrm/loanStatus/loanStatus";
import PaymentCollection from "../hrm/collection/paymentCollection";
import EmiDetails from "../hrm/collection/emiDetails";
import VisitorsList from "../hrm/visitors/visitors";
import FinancerVisitList from "../hrm/visitors/finvisitor";
import SdistributorList from "../hrm/visitors/sdisrtibutor";
import RetailerVisitorList from "../hrm/visitors/retailervisit";
import RegularVisitList from "../hrm/visitors/regularVisit";
import HistoryVisits from "../hrm/visitors/history-visits";
import AllVisitorsList from "../hrm/visitors/visitorList";
import ExpensesList from "../hrm/accounting/expenses";
import ViewRetailer from "../hrm/retailers/viewRetailers";
import ViewSuperDistributor from "../hrm/superDistributor/viewSuperDistriutor";
import ViewNational from "../hrm/employees/viewNational";
import ViewFinancers from "../hrm/financers/viewFinancer";
import ViewStaff from "../hrm/Staff/viewStaff";
import ViewProduct from "../hrm/products/viewProduct";
import ViewDistributor from "../hrm/distributor/viewDistributor";
import ViewDiscount from "../hrm/discounts/viewDiscount";
import AllVisitoredList from "../hrm/visitors/visitedList";
import CustomerCreation from "../hrm/customers/customerCreation";
import CustomerCreationWithAadhar from "../hrm/customers/customerCreationWithAadhar";
import ApplyForm from "../hrm/customers/applyForm";
import MasterList from "../hrm/accounting/masterList";
import PandLList from "../hrm/accounting/pandlList";
import CashList from "../hrm/accounting/cashList";
import BankList from "../hrm/accounting/bankList";
// import EmiCalculator from "";
import EmiCalculator from "../hrm/emi-calculator/emicalculator";
import VisitorsView from "../hrm/visitors/visitorsView";
import HistoryView from "../hrm/visitors/history-view";
import EmisData from "../hrm/EmisRecords/emisData";
import Cibil from "../hrm/cibilRecord/cibil";
import DisburseMent_Loan from "../hrm/customers/disbursement_Loan";
import PaymentsApproved from "../hrm/customers/payments";
import Approve_loan from "../hrm/customers/approve_loan";
import SecondVerificationList from "../hrm/verifications/verificationList";
import ViewVerfication from "../hrm/verifications/verficationView";
import Cheques from "../hrm/chequeRecords/cheques";
import FinancerData from "../hrm/financerData/financerdata";
import SupportPage from "../mainMenu/adminDashboard/support-page";
import SettingsPage from "../mainMenu/adminDashboard/settings";
import Download from "../pages/gallery/download-apk";
import VouchersList from "../hrm/vouchers/voucher";
import CompanyFinalData from "../hrm/companyStatement/companyFinalData";
import NpaDashboard from "../hrm/npaDashboard/npaDashboard";
import CustomerAllocation from "../hrm/customerAllocation";
import CustomerLogin from "../auth/login/customerLogin";
import DirectorCapital from "../hrm/directors/directorsCapitalList";
import AadharServiceLogs from "../hrm/aadharServiceLogs/aadharServiceLogs";
import HrmOperations from "../hrm/hrmOperations/hrmOperations";
import CrmPipeline from "../hrm/crm/crmPipeline";

const routes = all_routes;

export const nationalRoutes = [
  {
    path: "/",
    name: "Root",
    element: <Navigate to="/index" />,
    route: Route,
  },
  {
    path: routes.adminDashboard,
    element: <AdminDashboard />,
    route: Route,
  },
  {
    path: routes.employeeDashboard,
    element: <EmployeeDashboard />,
    route: Route,
  },
  {
    path: routes.leadsDashboard,
    element: <LeadsDasboard />,
    route: Route,
  },
  {
    path: routes.dealsDashboard,
    element: <DealsDashboard />,
    route: Route,
  },
  {
    path: routes.starter,
    element: <StarterPage />,
    route: Route,
  },
  {
    path: routes.calendar,
    element: <Calendars />,
    route: Route,
  },
  {
    path: routes.superAdminDashboard,
    element: <SuperAdminDashboard />,
    route: Route,
  },
  {
    path: routes.accordion,
    element: <Accordion />,
    route: Route,
  },
  {
    path: routes.avatar,
    element: <Avatar />,
    route: Route,
  },
  {
    path: routes.badges,
    element: <Badges />,
    route: Route,
  },
  {
    path: routes.border,
    element: <Borders />,
    route: Route,
  },
  {
    path: routes.breadcrums,
    element: <Breadcrumb />,
    route: Route,
  },
  {
    path: routes.button,
    element: <Buttons />,
    route: Route,
  },
  {
    path: routes.buttonGroup,
    element: <ButtonsGroup />,
    route: Route,
  },
  {
    path: routes.cards,
    element: <Cards />,
    route: Route,
  },
  {
    path: routes.carousel,
    element: <Carousel />,
    route: Route,
  },
  {
    path: routes.colors,
    element: <Colors />,
    route: Route,
  },
  {
    path: routes.dropdowns,
    element: <Dropdowns />,
    route: Route,
  },
  {
    path: routes.grid,
    element: <Grid />,
    route: Route,
  },
  {
    path: routes.images,
    element: <Images />,
    route: Route,
  },
  {
    path: routes.lightbox,
    element: <Lightboxes />,
    route: Route,
  },
  {
    path: routes.media,
    element: <Media />,
    route: Route,
  },
  {
    path: routes.modals,
    element: <Modals />,
    route: Route,
  },
  {
    path: routes.navTabs,
    element: <NavTabs />,
    route: Route,
  },
  {
    path: routes.offcanvas,
    element: <Offcanvas />,
    route: Route,
  },
  {
    path: routes.pagination,
    element: <Pagination />,
    route: Route,
  },
  {
    path: routes.popover,
    element: <Popovers />,
    route: Route,
  },
  {
    path: routes.rangeSlider,
    element: <RangeSlides />,
    route: Route,
  },
  {
    path: routes.progress,
    element: <Progress />,
    route: Route,
  },
  {
    path: routes.spinner,
    element: <Spinner />,
    route: Route,
  },

  {
    path: routes.typography,
    element: <Typography />,
    route: Route,
  },
  {
    path: routes.video,
    element: <Video />,
    route: Route,
  },
  {
    path: routes.sortable,
    element: <Sortable />,
    route: Route,
  },
  {
    path: routes.swiperjs,
    element: <Swiperjs />,
    route: Route,
  },
  {
    path: routes.bootstrapIcons,
    element: <BootstrapIcons />,
    route: Route,
  },
  {
    path: routes.toasts,
    element: <Toasts />,
    route: Route,
  },
  {
    path: routes.mapLeaflet,
    element: <Leaflet />,
    route: Route,
  },
  {
    path: routes.RemixIcons,
    element: <RemixIcons />,
    route: Route,
  },
  {
    path: routes.FlagIcons,
    element: <FlagIcons />,
    route: Route,
  },
  {
    path: routes.clipboard,
    element: <ClipBoard />,
    route: Route,
  },
  {
    path: routes.dragandDrop,
    element: <DragAndDrop />,
    route: Route,
  },
  {
    path: routes.rating,
    element: <Rating />,
    route: Route,
  },
  {
    path: routes.apexChart,
    element: <Apexchart />,
    route: Route,
  },
  {
    path: routes.primeChart,
    element: <PrimeReactChart />,
    route: Route,
  },
  {
    path: routes.chartJs,
    element: <ChartJSExample />,
    route: Route,
  },
  {
    path: routes.featherIcons,
    element: <FeatherIcons />,
    route: Route,
  },
  {
    path: routes.fontawesome,
    element: <FontawesomeIcons />,
    route: Route,
  },
  {
    path: routes.materialIcon,
    element: <MaterialIcons />,
    route: Route,
  },
  {
    path: routes.pe7icon,
    element: <PE7Icons />,
    route: Route,
  },
  {
    path: routes.simpleLineIcon,
    element: <SimplelineIcons />,
    route: Route,
  },
  {
    path: routes.themifyIcon,
    element: <ThemifyIcons />,
    route: Route,
  },
  {
    path: routes.typicon,
    element: <TypiconIcons />,
    route: Route,
  },
  {
    path: routes.basicInput,
    element: <BasicInputs />,
    route: Route,
  },
  {
    path: routes.weatherIcon,
    element: <WeatherIcons />,
    route: Route,
  },
  {
    path: routes.checkboxandRadion,
    element: <CheckboxRadios />,
    route: Route,
  },
  {
    path: routes.inputGroup,
    element: <InputGroup />,
    route: Route,
  },
  {
    path: routes.gridandGutters,
    element: <GridGutters />,
    route: Route,
  },
  {
    path: routes.formSelect,
    element: <FormSelect />,
    route: Route,
  },
  {
    path: routes.formMask,
    element: <FormMask />,
    route: Route,
  },
  {
    path: routes.fileUpload,
    element: <FileUpload />,
    route: Route,
  },
  {
    path: routes.horizontalForm,
    element: <FormHorizontal />,
    route: Route,
  },
  {
    path: routes.verticalForm,
    element: <FormVertical />,
    route: Route,
  },
  {
    path: routes.floatingLable,
    element: <FloatingLabel />,
    route: Route,
  },
  {
    path: routes.formValidation,
    element: <FormValidation />,
    route: Route,
  },
  {
    path: routes.reactSelect,
    element: <FormSelect2 />,
    route: Route,
  },
  {
    path: routes.formWizard,
    element: <FormWizard />,
    route: Route,
  },
  {
    path: routes.formPicker,
    element: <FormPikers />,
    route: Route,
  },
  {
    path: routes.tablesBasic,
    element: <TablesBasic />,
    route: Route,
  },
  {
    path: routes.iconicIcon,
    element: <IonicIcons />,
    route: Route,
  },
  {
    path: routes.placeholder,
    element: <Placeholder />,
    route: Route,
  },
  {
    path: routes.sweetalert,
    element: <Alert />,
    route: Route,
  },
  {
    path: routes.alert,
    element: <AlertUi />,
    route: Route,
  },
  {
    path: routes.tooltip,
    element: <Tooltips />,
    route: Route,
  },
  {
    path: routes.Horizontal,
    element: <LayoutDemo />,
  },
  {
    path: routes.Detached,
    element: <LayoutDemo />,
  },
  {
    path: routes.Modern,
    element: <LayoutDemo />,
  },
  {
    path: routes.TwoColumn,
    element: <LayoutDemo />,
  },
  {
    path: routes.Hovered,
    element: <LayoutDemo />,
  },
  {
    path: routes.layoutBox,
    element: <LayoutDemo />,
  },
  {
    path: routes.HorizontalSingle,
    element: <LayoutDemo />,
  },
  {
    path: routes.HorizontalOverlay,
    element: <LayoutDemo />,
  },
  {
    path: routes.HorizontalBox,
    element: <LayoutDemo />,
  },
  {
    path: routes.MenuAside,
    element: <LayoutDemo />,
  },
  {
    path: routes.Transparent,
    element: <LayoutDemo />,
  },
  {
    path: routes.WithoutHeader,
    element: <LayoutDemo />,
  },
  {
    path: routes.layoutRtl,
    element: <LayoutDemo />,
  },
  {
    path: routes.layoutDark,
    element: <LayoutDemo />,
  },

  //Settings
  {
    path: routes.profile,
    element: <Profile />,
  },
  {
    path: routes.gallery,
    element: <Gallery />,
  },
  {
    path: routes.privacyPolicy,
    element: <PrivacyPolicy />,
  },
  {
    path: routes.termscondition,
    element: <TermsCondition />,
  },
  {
    path: routes.knowledgebase,
    element: <Knowledgebase />,
  },
  {
    path: routes.invoiceDetails,
    element: <InvoiceDetails />,
  },
  {
    path: routes.superDistributorList,
    element: <SuperDistributorList />,
    route: Route,
  },
  {
    path: routes.usersListing,
    element: <UsersList />,
    route: Route,
  },
  {
    path: routes.productList,
    element: <ProductList />,
    route: Route,
  },
  {
    path: routes.discountList,
    element: <DiscountsList />,
    route: Route,
  },
  {
    path: routes.voucherList,
    element: <VouchersList />,
    route: Route,
  },
  {
    path: routes.advertisementList,
    element: <AdvertisementList />,
    route: Route,
  },
  {
    path: routes.customerList,
    element: <CustomersList />,
    route: Route,
  },
  {
    path: routes.aadharServiceLogs,
    element: <AadharServiceLogs />,
    route: Route,
  },

  {
    path: routes.customer_view,
    element: <CustomerLoanList />,
  },
  {
    path: routes.financesListing,
    element: <FinancersList />,
    route: Route,
  },
  {
    path: routes.expensesList,
    element: <ExpensesList />,
    route: Route,
  },
  {
    path: routes.cheques,
    element: <Cheques />,
    route: Route,
  },
  {
    path: routes.financerdata,
    element: <FinancerData />,
    route: Route,
  },
  {
    path: routes.retailerList,
    element: <ReatailersList />,
    route: Route,
  },
  {
    path: routes.distributorList,
    element: <DistributorList />,
    route: Route,
  },
  {
    path: routes.branchList,
    element: <BranchesList />,
    route: Route,
  },
  {
    path: routes.planList,
    element: <PlansList />,
    route: Route,
  },
  {
    path: routes.customercreation,
    element: <CustomerCreation />,
    route: Route,
  },
  {
    path: routes.staffList,
    element: <StaffList />,
    route: Route,
  },
];

export const publicRoutes = [
  {
    path: "/download-apk",
    name: "Root",
    element: <Download />,
    route: Route,
  },
  {
    path: "/",
    name: "Root",
    element: <Navigate to="/index" />,
    route: Route,
  },
  {
    path: routes.adminDashboard,
    element: <AdminDashboard />,
    route: Route,
  },
  {
    path: routes.employeeDashboard,
    element: <EmployeeDashboard />,
    route: Route,
  },
  {
    path: routes.leadsDashboard,
    element: <LeadsDasboard />,
    route: Route,
  },
  {
    path: routes.directorCapital,
    element: <DirectorCapital />,
    route: Route,
  },
  {
    path: routes.directorList,
    element: <DirectorList />,
    route: Route,
  },
  {
    path: routes.dealsDashboard,
    element: <DealsDashboard />,
    route: Route,
  },
  {
    path: routes.customercreation,
    element: <CustomerCreation />,
    route: Route,
  },
  {
    path: routes.applyform,
    element: <ApplyForm />,
    route: Route,
  },
  {
    path: routes.customeraadharcreation,
    element: <CustomerCreationWithAadhar />,
    route: Route,
  },

  {
    path: routes.starter,
    element: <StarterPage />,
    route: Route,
  },
  {
    path: routes.calendar,
    element: <Calendars />,
    route: Route,
  },
  {
    path: routes.superAdminDashboard,
    element: <SuperAdminDashboard />,
    route: Route,
  },
  {
    path: routes.accordion,
    element: <Accordion />,
    route: Route,
  },
  {
    path: routes.avatar,
    element: <Avatar />,
    route: Route,
  },
  {
    path: routes.badges,
    element: <Badges />,
    route: Route,
  },
  {
    path: routes.border,
    element: <Borders />,
    route: Route,
  },
  {
    path: routes.breadcrums,
    element: <Breadcrumb />,
    route: Route,
  },
  {
    path: routes.button,
    element: <Buttons />,
    route: Route,
  },
  {
    path: routes.buttonGroup,
    element: <ButtonsGroup />,
    route: Route,
  },
  {
    path: routes.cards,
    element: <Cards />,
    route: Route,
  },
  {
    path: routes.carousel,
    element: <Carousel />,
    route: Route,
  },
  {
    path: routes.colors,
    element: <Colors />,
    route: Route,
  },
  {
    path: routes.dropdowns,
    element: <Dropdowns />,
    route: Route,
  },
  {
    path: routes.grid,
    element: <Grid />,
    route: Route,
  },
  {
    path: routes.images,
    element: <Images />,
    route: Route,
  },
  {
    path: routes.lightbox,
    element: <Lightboxes />,
    route: Route,
  },
  {
    path: routes.media,
    element: <Media />,
    route: Route,
  },
  {
    path: routes.modals,
    element: <Modals />,
    route: Route,
  },
  {
    path: routes.navTabs,
    element: <NavTabs />,
    route: Route,
  },
  {
    path: routes.offcanvas,
    element: <Offcanvas />,
    route: Route,
  },
  {
    path: routes.pagination,
    element: <Pagination />,
    route: Route,
  },
  {
    path: routes.popover,
    element: <Popovers />,
    route: Route,
  },
  {
    path: routes.rangeSlider,
    element: <RangeSlides />,
    route: Route,
  },
  {
    path: routes.progress,
    element: <Progress />,
    route: Route,
  },
  {
    path: routes.spinner,
    element: <Spinner />,
    route: Route,
  },

  {
    path: routes.typography,
    element: <Typography />,
    route: Route,
  },
  {
    path: routes.video,
    element: <Video />,
    route: Route,
  },
  {
    path: routes.sortable,
    element: <Sortable />,
    route: Route,
  },
  {
    path: routes.swiperjs,
    element: <Swiperjs />,
    route: Route,
  },
  {
    path: routes.bootstrapIcons,
    element: <BootstrapIcons />,
    route: Route,
  },
  {
    path: routes.toasts,
    element: <Toasts />,
    route: Route,
  },
  {
    path: routes.mapLeaflet,
    element: <Leaflet />,
    route: Route,
  },
  {
    path: routes.RemixIcons,
    element: <RemixIcons />,
    route: Route,
  },
  {
    path: routes.FlagIcons,
    element: <FlagIcons />,
    route: Route,
  },
  {
    path: routes.clipboard,
    element: <ClipBoard />,
    route: Route,
  },
  {
    path: routes.dragandDrop,
    element: <DragAndDrop />,
    route: Route,
  },
  {
    path: routes.rating,
    element: <Rating />,
    route: Route,
  },
  {
    path: routes.apexChart,
    element: <Apexchart />,
    route: Route,
  },
  {
    path: routes.primeChart,
    element: <PrimeReactChart />,
    route: Route,
  },
  {
    path: routes.chartJs,
    element: <ChartJSExample />,
    route: Route,
  },
  {
    path: routes.featherIcons,
    element: <FeatherIcons />,
    route: Route,
  },
  {
    path: routes.fontawesome,
    element: <FontawesomeIcons />,
    route: Route,
  },
  {
    path: routes.materialIcon,
    element: <MaterialIcons />,
    route: Route,
  },
  {
    path: routes.pe7icon,
    element: <PE7Icons />,
    route: Route,
  },
  {
    path: routes.simpleLineIcon,
    element: <SimplelineIcons />,
    route: Route,
  },
  {
    path: routes.themifyIcon,
    element: <ThemifyIcons />,
    route: Route,
  },
  {
    path: routes.typicon,
    element: <TypiconIcons />,
    route: Route,
  },
  {
    path: routes.basicInput,
    element: <BasicInputs />,
    route: Route,
  },
  {
    path: routes.weatherIcon,
    element: <WeatherIcons />,
    route: Route,
  },
  {
    path: routes.checkboxandRadion,
    element: <CheckboxRadios />,
    route: Route,
  },
  {
    path: routes.inputGroup,
    element: <InputGroup />,
    route: Route,
  },
  {
    path: routes.gridandGutters,
    element: <GridGutters />,
    route: Route,
  },
  {
    path: routes.formSelect,
    element: <FormSelect />,
    route: Route,
  },
  {
    path: routes.formMask,
    element: <FormMask />,
    route: Route,
  },
  {
    path: routes.fileUpload,
    element: <FileUpload />,
    route: Route,
  },
  {
    path: routes.horizontalForm,
    element: <FormHorizontal />,
    route: Route,
  },
  {
    path: routes.verticalForm,
    element: <FormVertical />,
    route: Route,
  },
  {
    path: routes.floatingLable,
    element: <FloatingLabel />,
    route: Route,
  },
  {
    path: routes.formValidation,
    element: <FormValidation />,
    route: Route,
  },
  {
    path: routes.reactSelect,
    element: <FormSelect2 />,
    route: Route,
  },
  {
    path: routes.formWizard,
    element: <FormWizard />,
    route: Route,
  },
  {
    path: routes.formPicker,
    element: <FormPikers />,
    route: Route,
  },
  {
    path: routes.tablesBasic,
    element: <TablesBasic />,
    route: Route,
  },
  {
    path: routes.iconicIcon,
    element: <IonicIcons />,
    route: Route,
  },
  {
    path: routes.placeholder,
    element: <Placeholder />,
    route: Route,
  },
  {
    path: routes.sweetalert,
    element: <Alert />,
    route: Route,
  },
  {
    path: routes.alert,
    element: <AlertUi />,
    route: Route,
  },
  {
    path: routes.tooltip,
    element: <Tooltips />,
    route: Route,
  },
  {
    path: routes.Horizontal,
    element: <LayoutDemo />,
  },
  {
    path: routes.Detached,
    element: <LayoutDemo />,
  },
  {
    path: routes.Modern,
    element: <LayoutDemo />,
  },
  {
    path: routes.TwoColumn,
    element: <LayoutDemo />,
  },
  {
    path: routes.Hovered,
    element: <LayoutDemo />,
  },
  {
    path: routes.layoutBox,
    element: <LayoutDemo />,
  },
  {
    path: routes.HorizontalSingle,
    element: <LayoutDemo />,
  },
  {
    path: routes.HorizontalOverlay,
    element: <LayoutDemo />,
  },
  {
    path: routes.HorizontalBox,
    element: <LayoutDemo />,
  },
  {
    path: routes.MenuAside,
    element: <LayoutDemo />,
  },
  {
    path: routes.Transparent,
    element: <LayoutDemo />,
  },
  {
    path: routes.WithoutHeader,
    element: <LayoutDemo />,
  },
  {
    path: routes.layoutRtl,
    element: <LayoutDemo />,
  },
  {
    path: routes.layoutDark,
    element: <LayoutDemo />,
  },

  //Settings
  {
    path: routes.profile,
    element: <Profile />,
  },
  {
    path: routes.gallery,
    element: <Gallery />,
  },
  {
    path: routes.emisdata,
    element: <EmisData />,
  },
  {
    path: routes.cibil,
    element: <Cibil />,
  },
  {
    path: routes.disbursement_loan,
    element: <DisburseMent_Loan />,
  },
  {
    path: routes.company_statement,
    element: <CompanyFinalData />,
  },
  {
    path: routes.npa_dashboard,
    element: <NpaDashboard />,
  },
  {
    path: routes.customer_allocation,
    element: <CustomerAllocation />,
  },
  {
    path: routes.payments_approved,
    element: <PaymentsApproved />,
  },
  {
    path: routes.approve_loan,
    element: <Approve_loan />,
  },
  {
    path: routes.privacyPolicy,
    element: <PrivacyPolicy />,
  },
  {
    path: routes.termscondition,
    element: <TermsCondition />,
  },
  {
    path: routes.knowledgebase,
    element: <Knowledgebase />,
  },
  {
    path: routes.invoiceDetails,
    element: <InvoiceDetails />,
  },
  {
    path: routes.invoicesdetails,
    element: <InvoiceDetails />,
    route: Route,
  },
  {
    path: routes.employeeList,
    element: <EmployeeList />,
    route: Route,
  },
  {
    path: routes.hrmOperations,
    element: <HrmOperations />,
    route: Route,
  },
  {
    path: routes.crmPipeline,
    element: <CrmPipeline />,
    route: Route,
  },
  {
    path: routes.superDistributorList,
    element: <SuperDistributorList />,
    route: Route,
  },
  {
    path: routes.usersListing,
    element: <UsersList />,
    route: Route,
  },
  {
    path: routes.productList,
    element: <ProductList />,
    route: Route,
  },
  {
    path: routes.productNameList,
    element: <ProductNameList />,
    route: Route,
  },
  {
    path: routes.discountList,
    element: <DiscountsList />,
    route: Route,
  },
  {
    path: routes.voucherList,
    element: <VouchersList />,
    route: Route,
  },
  {
    path: routes.directorList,
    element: <DirectorList />,
    route: Route,
  },
  {
    path: routes.advertisementList,
    element: <AdvertisementList />,
    route: Route,
  },
  {
    path: routes.customerList,
    element: <CustomersList />,
    route: Route,
  },
  {
    path: routes.aadharServiceLogs,
    element: <AadharServiceLogs />,
    route: Route,
  },
  {
    path: routes.visitors,
    element: <VisitorsList />,
    route: Route,
  },

  {
    path: routes.pandl_list,
    element: <PandLList />,
    route: Route,
  },
  {
    path: routes.master_list,
    element: <MasterList />,
    route: Route,
  },
  {
    path: routes.cash_list,
    element: <CashList />,
    route: Route,
  },
  {
    path: routes.bank_list,
    element: <BankList />,
    route: Route,
  },
  {
    path: routes.emi_calculator,
    element: <EmiCalculator />,
    route: Route,
  },
  {
    path: routes.visitorsview,
    element: <VisitorsView />,
    route: Route,
  },
  {
    path: "/history-view",
    element: <HistoryView />,
    route: Route,
  },

  {
    path: routes.visitors_dist,
    element: <SdistributorList />,
    route: Route,
  },
  {
    path: routes.visitors_financer,
    element: <FinancerVisitList />,
    route: Route,
  },
  {
    path: routes.visitors_retailer,
    element: <RetailerVisitorList />,
    route: Route,
  },
  {
    path: routes.regular_visitors,
    element: <RegularVisitList />,
    route: Route,
  },
  {
    path: routes.history_visits,
    element: <HistoryVisits />,
    route: Route,
  },
  {
    path: routes.all_visitors,
    element: <AllVisitorsList />,
    route: Route,
  },
  {
    path: routes.visitedLists,
    element: <AllVisitoredList />,
    route: Route,
  },
  {
    path: routes.viewVerification,
    element: <ViewVerfication />,
    route: Route,
  },
  {
    path: routes.customer_view,
    element: <CustomerLoanList />,
  },
  {
    path: routes.verificationList,
    element: <VerificationList />,
  },
  {
    path: routes.secondverificationlist,
    element: <SecondVerificationList />,
  },
  {
    path: routes.loanstatus,
    element: <LoanStatus />,
  },
  {
    path: routes.paymentcollection,
    element: <PaymentCollection />,
  },
  {
    path: routes.emidetails,
    element: <EmiDetails />,
  },
  {
    path: routes.financesListing,
    element: <FinancersList />,
    route: Route,
  },
  {
    path: routes.expensesList,
    element: <ExpensesList />,
    route: Route,
  },
  {
    path: routes.cheques,
    element: <Cheques />,
    route: Route,
  },
  {
    path: routes.financerdata,
    element: <FinancerData />,
    route: Route,
  },
  {
    path: routes.retailerList,
    element: <ReatailersList />,
    route: Route,
  },
  {
    path: routes.viewRetailers,
    element: <ViewRetailer />,
    route: Route,
  },
  {
    path: routes.viewSuper,
    element: <ViewSuperDistributor />,
    route: Route,
  },
  {
    path: routes.viewNational,
    element: <ViewNational />,
    route: Route,
  },
  {
    path: routes.ViewFinancers,
    element: <ViewFinancers />,
    route: Route,
  },
  {
    path: routes.viewStaff,
    element: <ViewStaff />,
    route: Route,
  },
  {
    path: routes.viewProduct,
    element: <ViewProduct />,
    route: Route,
  },
  {
    path: routes.distributorList,
    element: <DistributorList />,
    route: Route,
  },
  {
    path: routes.viewdistributor,
    element: <ViewDistributor />,
    route: Route,
  },
  {
    path: routes.viewdiscount,
    element: <ViewDiscount />,
    route: Route,
  },
  {
    path: routes.branchList,
    element: <BranchesList />,
    route: Route,
  },
  {
    path: routes.planList,
    element: <PlansList />,
    route: Route,
  },
  {
    path: routes.staffList,
    element: <StaffList />,
    route: Route,
  },
  {
    path: routes.paidEmiList,
    element: <PaidEmiList />,
    route: Route,
  },
  {
    path: routes.pendingEmiList,
    element: <PendingEmisList />,
    route: Route,
  },
  {
    path: "/support",
    element: <SupportPage />,
    route: Route,
  },
  {
    path: "/settings",
    element: <SettingsPage />,
    route: Route,
  },
];

export const authRoutes = [
  { path: routes.evCustomers, element: <EvLoans />, route: Route },
  { path: routes.evApply, element: <EvApplyPage />, route: Route },
  { path: routes.evCustomerCreate, element: <EvCustomerPage />, route: Route },
  { path: routes.evCustomerView, element: <EvCustomerPage />, route: Route },
  { path: routes.evProducts, element: <EvLoans />, route: Route },
  { path: routes.evCustomerLoans, element: <EvLoans />, route: Route },
  { path: routes.evDisbursements, element: <EvLoans />, route: Route },
  { path: routes.evCollections, element: <EvLoans />, route: Route },
  { path: routes.evEmiDetails, element: <EvLoans />, route: Route },
  { path: routes.evLoanRecord, element: <EvLoanRecordPage />, route: Route },
  { path: routes.evLoanDisbursement, element: <EvLoanDisbursementPage />, route: Route },
  {
    path: "/download-apk",
    name: "Root",
    element: <Download />,
    route: Route,
  },
  {
    path: routes.comingSoon,
    element: <ComingSoon />,
    route: Route,
  },
  {
    path: routes.login,
    element: <Login />,
    route: Route,
  },
  {
    path: routes.customerLogin,
    element: <CustomerLogin />,
    route: Route,
  },
  {
    path: routes.register,
    element: <Register />,
    route: Route,
  },
  {
    path: routes.twoStepVerification,
    element: <TwoStepVerification />,
    route: Route,
  },
  {
    path: routes.twoStepVerification2,
    element: <TwoStepVerification2 />,
    route: Route,
  },
  {
    path: routes.twoStepVerification3,
    element: <TwoStepVerification3 />,
    route: Route,
  },
  {
    path: routes.register,
    element: <Register />,
    route: Route,
  },
  {
    path: routes.resetPassword,
    element: <ResetPassword />,
    route: Route,
  },
  {
    path: routes.resetPassword2,
    element: <ResetPassword2 />,
    route: Route,
  },
  {
    path: routes.resetPassword3,
    element: <ResetPassword3 />,
    route: Route,
  },
  {
    path: routes.forgotPassword,
    element: <ForgotPassword />,
    route: Route,
  },
  {
    path: routes.error404,
    element: <Error404 />,
    route: Route,
  },
  {
    path: routes.error500,
    element: <Error500 />,
    route: Route,
  },
  {
    path: routes.underMaintenance,
    element: <UnderMaintenance />,
    route: Route,
  },
  {
    path: routes.underConstruction,
    element: <UnderConstruction />,
  },
  {
    path: routes.lockScreen,
    element: <LockScreen />,
  },
  {
    path: routes.resetPasswordSuccess,
    element: <ResetPasswordSuccess />,
  },
  {
    path: routes.resetPasswordSuccess2,
    element: <ResetPasswordSuccess2 />,
  },
  {
    path: routes.resetPasswordSuccess3,
    element: <ResetPasswordSuccess3 />,
  },
];
